const awsmobile = {
    Auth: {
        Cognito: {
            region: "eu-central-1",
            userPoolId: "eu-central-1_oIJq3qG5H",
            userPoolClientId: "4poria6unkepp698k09qoebk7s",
            identityPoolId: "eu-central-1:c7996793-1d1d-44e4-9744-a73a6d19d268",
        },
        mandatorySignIn: true,
        authenticationFlowType: "USER_SRP_AUTH",
        passwordProtectionSettings: {
            passwordPolicyMinLength: 8,
            passwordPolicyCharacters: [],
        },
        verificationMechanisms: [],
    },
    Storage: {
        S3: {
            bucket: "bronze-tracker",
            region: "eu-central-1"
        }
    },
    API: {
        GraphQL: {
            endpoint: "https://gjqelkjaxfh5ze35gnfxxgm4du.appsync-api.eu-central-1.amazonaws.com/graphql",
            region: "eu-central-1",
            defaultAuthMode: "userPool"
        },
        REST: {
            "PRO-ticket-API": {
                endpoint: "https://nc0f9miymb.execute-api.eu-central-1.amazonaws.com/prod",
                "region": "eu-central-1"
            },
            "WEBAPP-API": {
                endpoint: "https://webapp-api.bronze.vision",
                region: 'eu-central-1',
            },
            "PRO-notification-API": {
                endpoint: "https://modals.bronze.vision/",
                region: 'eu-central-1',
            }
        },
        Events: {
            endpoint: "https://xoi4l6hl3nh5jgzsffb5qlyu4q.appsync-api.eu-central-1.amazonaws.com/event",
            region: 'eu-central-1',
            defaultAuthMode: 'userPool'          
        }
    }
};

export default awsmobile;
